import { useState } from 'react'
import {
  noticeRegistration,
  noticeStorageKey,
  RegistrationNoticeDialog,
  useActiveParticipantOlympiads,
  useRecentFinishedParticipantOlympiads,
} from '@entities/olympiad'
import { useAuth } from '@shared/auth/authContext'
import { ROLES } from '@shared/config/constants'
import { pendingNoticeOlympiads } from '../model/pendingNotices'
import { useParticipantNoticesSuspended } from '../model/suspension'
import { ProfileCityNotice } from './ProfileCityNotice'

function Host() {
  const active = useActiveParticipantOlympiads()
  const finished = useRecentFinishedParticipantOlympiads()
  const suspended = useParticipantNoticesSuspended()
  // Закрытое окно пишет отметку в localStorage — это не состояние React, а
  // хранилище может быть закрыто. Поэтому закрытые за сессию ключи держим здесь:
  // их смена пересчитывает очередь, и закрытое окно не застревает в её голове.
  const [dismissed, setDismissed] = useState<ReadonlySet<string>>(() => new Set())
  const [nowMs] = useState(Date.now)

  const [next] = pendingNoticeOlympiads(active.data ?? [], finished.data ?? [], nowMs, dismissed)
  const registration = next ? noticeRegistration(next) : null
  // Окно профиля — после окон отмены: по одному, а не стопкой. Пока списки
  // грузятся, окно отмены ещё может появиться, поэтому профиль ждёт; ошибка
  // списка считается «пусто», чтобы не блокировать его навсегда.
  if (!next || !registration) {
    return active.isPending || finished.isPending ? null : (
      <ProfileCityNotice suspended={suspended} />
    )
  }

  const key = noticeStorageKey(registration)
  return (
    <RegistrationNoticeDialog
      key={key}
      olympiad={next}
      suspended={suspended}
      onClosed={() => setDismissed((prev) => new Set(prev).add(key))}
    />
  )
}

/**
 * Окна отмены и дисквалификации на любой странице кабинета участника, по
 * одному. У админа и представителя — ничего: ни запросов, ни разметки.
 */
export function ParticipantNotices() {
  const { role } = useAuth()
  if (role !== ROLES.PARTICIPANT) return null
  return <Host />
}
